class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.variantPickerChangeHandler =
      this.variantPickerChangeHandler.bind(this);
    this.productChangeHandler = this.productChangeHandler.bind(this);
    this.addToCartHandler = this.addToCart.bind(this);
    this.clickPreOrderOnRender = false;
  }

  connectedCallback() {
    this.addEventListener("product-change", this.productChangeHandler);
    this.addEventListener(
      "variant-picker:change",
      this.variantPickerChangeHandler
    );
    this.form = this.querySelector("form");
    if (this.form) {
      this.form.addEventListener("submit", this.addToCartHandler);
    }
  }

  disconnectedCallback() {
    this.removeEventListener("product-change", this.productChangeHandler);
    this.removeEventListener(
      "variant-picker:change",
      this.variantPickerChangeHandler
    );
    if (this.form) {
      this.form.removeEventListener("submit", this.addToCartHandler);
    }
  }

  productChangeHandler(event) {
    this.renderProduct(event.detail);
  }

  variantPickerChangeHandler(event) {
    this.clickPreOrderOnRender = false;
    if (event.target.closest(".product-cards-complete-set")) {
      this.clickPreOrderOnRender = true;
    }
    this.renderProduct(this.dataset.handle, event.detail.variantID);
  }

  renderProduct(handle, variantId) {
    const url = `/products/${handle}?view=${this.dataset.view}${
      variantId ? `&variant=${variantId}` : ""
    }`;
    const cache = window.productsCache || {};
    if (cache[url]) {
      this.outerHTML = cache[url];
      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      return;
    }
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        // Parse section HTML from response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        let sectionHTML = doc.querySelector("main-product")?.outerHTML;

        if (sectionHTML) {
          if (!window.productsCache) {
            window.productsCache = {};
          }
          window.productsCache[url] = sectionHTML; // Cache the section HTML
          const mainProductParent = this.parentElement;
          this.outerHTML = sectionHTML;
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          if (this.clickPreOrderOnRender) {
            const preOrderButton = mainProductParent
              .querySelector("main-product")
              .querySelector(".product-item__btn-add");
            if (preOrderButton) preOrderButton.click();
          }
        }
      });
  }

  addToCart(e) {
    e.preventDefault();
    if (
      this.hasAttribute("card") &&
      !window.matchMedia("(min-width: 1024px)").matches &&
      !this.closest(".product-cards-complete-set")
    ) {
      document.dispatchEvent(
        new CustomEvent("quick-view:open", {
          detail: {
            handle: this.dataset.handle,
            variantId: this.form.querySelector('[name="id"]').value,
          },
        })
      );
    } else {
      const isTemplateCart = document.querySelector("body.template-cart");
      const isFromCompleteSet = this.closest(".product-cards-complete-set");
      window.addToCart(
        jQuery(this.form),
        isFromCompleteSet
          ? isTemplateCart
            ? false
            : true
          : this.form.querySelector('[name="id"]').value
      );
    }
  }
}

customElements.define("main-product", MainProduct);
